import { SustainabilityClassification } from '@/domains/sustainability/productPage/types';
import { Attribute } from '@/productDiscovery/ProductPage/interfaces/Detail.common.model';

const sustainableClassifications: SustainabilityClassification[] = [
  {
    type: 'madeInFrance',
    attributeName: 'Certification environnementale',
    isSustainable: (value) => ['Origine France Garantie'].includes(value),
  },
  {
    type: 'responsible',
    attributeName: 'Certification environnementale',
    isSustainable: (value) =>
      [
        'NF environnement',
        'GOTS',
        'Ecocert',
        'Ecocert soin des animaux',
        'Carbon Trust',
        'Ecolabel Européen',
        'GOLS',
      ].includes(value),
  },
  {
    type: 'responsibleAgriculture',
    attributeName: 'Certification environnementale',
    isSustainable: (value) =>
      [
        'Utilisable en agriculture biologique',
        'Agriculture biologique',
      ].includes(value),
  },
  {
    type: 'responsibleWood',
    attributeName: 'Certification environnementale',
    isSustainable: (value) => ['PEFC', 'FSC', 'Nature Plus'].includes(value),
  },
  {
    type: 'responsibleFabric',
    attributeName: 'Certification environnementale',
    isSustainable: (value) =>
      [
        'Oeko-Tex',
        'Oeko-Tex Made in Green',
        'Ecocert textile',
        'Oeko-Tex Standard 100',
      ].includes(value),
  },
  {
    type: 'energyEfficient',
    attributeName: 'Certification environnementale',
    isSustainable: (value) =>
      [
        'Flamme Verte 7*',
        'NF Électricité Performance',
        'NF électricité Performance 3 étoiles',
        'NF électricité Performance 3 étoiles œil',
      ].includes(value),
  },
  {
    type: 'responsiblePlants',
    attributeName: 'Certification environnementale',
    isSustainable: (value) =>
      ['Plante bleue', 'Fleur de France'].includes(value),
  },
  {
    type: 'durable',
    attributeName: 'Certification environnementale',
    isSustainable: (value) => ['Longtime'].includes(value),
  },
  {
    type: 'energyEfficient',
    attributeName: 'Classe efficacité énergétique',
    isSustainable: (value) => ['A', 'A+', 'A++', 'A+++', 'B'].includes(value),
  },
  {
    type: 'healthyAir',
    attributeName: 'Qualité air intérieur',
    isSustainable: (value) => ['A+'].includes(value),
  },
  {
    type: 'madeInFrance',
    attributeName: 'Origine',
    isSustainable: (value) => ['Fabriqué en France'].includes(value),
  },
  {
    type: 'madeInEurope',
    attributeName: 'Origine',
    isSustainable: (value) =>
      [
        'Fabriqué en Italie',
        'Fabriqué en Allemagne',
        'Fabriqué au Royaume-Uni',
        'Fabriqué en Espagne',
        'Fabriqué au Portugal',
        'Fabriqué en Belgique',
        'Fabriqué en Europe',
        'Fabriqué aux Pays-Bas',
        'Fabriqué en Pologne',
        'Fabriqué en Hongrie',
        'Fabriqué en Slovénie',
        'Fabriqué en Lettonie',
        'Fabriqué en Lituanie',
        'Fabriqué en Suède',
        'Fabriqué en République tchèque',
        'Fabriqué en Autriche',
        'Fabriqué en Suisse',
        'Fabriqué au Danemark',
        'Fabriqué en Roumanie',
        'Fabriqué en Bulgarie',
        'Fabriqué en Grèce',
        'Fabriqué en Slovaquie',
        'Fabriqué au Luxembourg',
        'Fabriqué en Finlande',
        'Fabriqué en Irlande',
        'Fabriqué à Monaco',
        'Fabriqué en Norvège',
        'Fabriqué en Estonie',
      ].includes(value),
  },
  {
    type: 'energyEfficient',
    attributeName: 'Caractéristiques RSE',
    isSustainable: (value) =>
      ["Permet des économies d'énergie"].includes(value),
  },
  {
    type: 'durable',
    attributeName: 'Disponibilité des pièces détachées',
    isSustainable: (value) => Number.parseInt(value, 10) >= 5,
  },
  {
    type: 'durable',
    attributeName: 'Indice de réparabilité',
    isSustainable: (value) => Number.parseFloat(value) >= 7.6,
  },
];

export const findRelevantClassifications = (
  attribute: Attribute,
): SustainabilityClassification | undefined =>
  sustainableClassifications.find(
    (sustainabilityClass) =>
      attribute.name.trim() === sustainabilityClass.attributeName,
  );

export const findSustainableClassifications = (
  attribute: Attribute,
): SustainabilityClassification | undefined =>
  sustainableClassifications.find(
    (sustainabilityClass) =>
      attribute.name.trim() === sustainabilityClass.attributeName &&
      sustainabilityClass.isSustainable(attribute.value),
  );
